
define('text!templates/content/orders.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n        <div class="main-list-container">\n\n        </div>\n    </div>\n</div>\n';});

